export interface IClientVerificationRequest {
    phone: string;
    email: string;
}

export class ClientVerificationRequest implements IClientVerificationRequest {
    phone: string;
    email: string;

    constructor(params: Partial<IClientVerificationRequest> = {}) {
        const {
            phone = '',
            email = ''
        } = params;

        this.phone = phone;
        this.email = email;
    }
}
